/**
 * @returns {object}
 */
function getAllCookies () {
  if (typeof document === 'undefined') return {}

  const value = document?.cookie
  const cookies = value?.split(';')
  const parsed = {}

  cookies?.forEach(cookie => {
    const cookieCrumbles = cookie.split('=')

    if (cookieCrumbles.length === 2) {
      const key = cookieCrumbles[0].trim()
      const val = cookieCrumbles[1].trim()

      parsed[key] = parsed?.[key] || val
    }
  })

  return parsed
}

module.exports = { getAllCookies }
